import { render, staticRenderFns } from "./ConfigModeSection.vue?vue&type=template&id=2063a994"
import script from "./ConfigModeSection.vue?vue&type=script&lang=js"
export * from "./ConfigModeSection.vue?vue&type=script&lang=js"
import style0 from "./ConfigModeSection.vue?vue&type=style&index=0&id=2063a994&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports